import React from 'react';

const ImageLoader = ({image,style}) => (
    <img src={image} style={style} alt=""/>
)

export default ImageLoader